
import React from 'react'
import {connect} from "react-redux"

import Video from '../video/Video';


import './styles/AdminTherapyArea.scss';
import deleteImage from '../../images/icons/close_black.svg';


import { adminSaveTherapyArea, adminToggleVideoTherapyArea } from "../../actions/admin"

@connect((store) => {
	return {
		therapy_areas: store.therapy_areas,
		videos: store.videos
	}
})

class AdminTherapyArea extends React.Component {
  constructor(props) {
		super(props);
    this.edit = this.edit.bind(this);
    this.save = this.save.bind(this);
    this.editOptions = this.editOptions.bind(this);
    this.displayOptions = this.displayOptions.bind(this);
    this.handleItemChange = this.handleItemChange.bind(this);
		this.populateVideos = this.populateVideos.bind(this);
		this.removeVideo = this.removeVideo.bind(this);
    this.state = {
      editing:false,
      item: this.props.area,
			itemVideos : this.populateVideos()
    }
  }


	removeVideo(videoId){
		this.props.dispatch(adminToggleVideoTherapyArea(this.state.item, videoId))
	}

  save(){
    this.props.dispatch(adminSaveTherapyArea(this.state.item));
    this.edit();
  }

  handleItemChange(e, field){
    let item = this.state.item;
		item[field] = e.target.value;
		this.setState({item: item})
  }

  edit(){
    this.setState({
      'editing': !this.state.editing
    });
  }

	populateVideos(){
		if(this.props.area){
			return this.props.area.videos.reduce((collection,videoId) => {
				collection[videoId] = this.props.videos[videoId];
				return collection;
			}, {})
		} else {
			return {}
		}
	}

  editOptions(){
    if(this.state.editing){
      return <div>
        <button className="md-button md-accent md-raised link" onClick={this.save} >Save</button>
        &nbsp;  <a className="link" onClick={this.edit}>Cancel</a>
      </div>;
    }else{
      return <div>
        <a className="link" onClick={this.edit}>Edit</a>
      </div>;
    }
  }

  displayOptions(){
    if(this.state.editing){
      return <div>
				<h6 className='md-subhead'>
	        <input className="md-input md-title mb1"
	          onChange={(e)=>this.handleItemChange(e, 'name')}
	          value={this.state.item.name}
	          type="text" placeholder="Therapy area title"  />
				</h6>
        <input
          className="md-input md-title mb1"
          placeholder="Admin note"
          onChange={e => this.handleItemChange(e, "adminNote")}
          value={this.state.item.adminNote}
          type="text"
        />
        <textarea className="md-input multiple"
          value={this.state.item.description}
          placeholder="Therapy area description"
          onChange={(e)=>this.handleItemChange(e, 'description')}
          />

				<br />
					<p>Videos</p>
					<div className="video-grid grid">
						{ this.state.item.videos.map(videoId => this.state.itemVideos[videoId]?
							<Video key={videoId} video={this.props.videos[videoId]} >
								<button className="corner-action md-button md-icon"
									onClick={()=>this.removeVideo(videoId)}><img src={deleteImage}  alt="Remove" /></button>
							</Video>
							:
							null
						)}
					</div>
      </div>;
    }else{
      return <div>
        <h6 className='md-subhead'>{this.state.item.name}</h6>
        <p>{this.state.item.description}</p>
      </div>;
    }
  }

  render () {
    return <li className={"therapy-area  card  " + (this.state.editing? 'editing' : '')} >
      <div className="row-fill">
        {this.displayOptions()}

      </div>
			<div className="component-footer reading">
				{this.editOptions()}
				<div onClick={() => {
						this.props.handleDelete(this.props.area._id)
					}} className="delete"><img src={deleteImage} alt="Delete" /></div>
			</div>
    </li>
  }
}

export default AdminTherapyArea;



// WEBPACK FOOTER //
// ./src/components/admin/AdminTherapyArea.jsx